@import 'styles/mixins';
@import 'styles/variables';

.datePickerField {
  color: $gray-40;
  &:focus-within {
    .icon {
      path {
        fill: $green-50;
      }
    }
  }
  &:hover {
    .icon {
      path {
        fill: $green-50;
      }
    }
  }
}

.icon {
  position: relative;
  left: 30px;
  margin-left: -14px;
  vertical-align: middle;
  height: 14px;
  width: 14px;
  z-index: 1;
  path {
    fill: $grey-30;
  }
}

.picker {
  width: 100%;
  &:hover {
    :global(.ant-calendar-picker-input:not(.ant-input-disabled)) {
      border-color: $green-50;
    }
  }
  :global(.ant-calendar-picker-input) {
    @include md-regular;
    background: $white;
    border: 1px solid $grey-20;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 10px 4px 10px 34px;
    height: 38px;
    color: $grey-90;
    &:focus {
      border: 1px solid $green-50;
      box-shadow: 0 0 0 3px rgba(0, 163, 158, 0.11);
    }
    &.withIcon {
      padding-left: 40px;
    }
  }
}

.error {
  border-color: $red-40;
  background-color: $red-10;
}

.errorMessage {
  @include ui-sm-text;
  color: $red-40;
  margin-bottom: 8px;
}

.label {
  @include ui-sm-text;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
}
